import { render, staticRenderFns } from "./productsList.vue?vue&type=template&id=611b8620&scoped=true&"
import script from "./productsList.vue?vue&type=script&lang=js&"
export * from "./productsList.vue?vue&type=script&lang=js&"
import style0 from "./productsList.vue?vue&type=style&index=0&id=611b8620&lang=scss&scoped=true&"
import style1 from "./productsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611b8620",
  null
  
)

export default component.exports